export default "__VITE_ASSET__CiHB1wiJ__"